import { selector, observer } from '../other/animations.js';

/* global FWP */
// Search results page, on click of a custom button click the facetwp button
$('#filters-view .c-button').click(function () {
    $('.facetwp-search-wrap .facetwp-btn').click();
    return false;
});

$(document).on('change', '.js-facetwp-pager', function () {
    FWP.paged = $(this).val();
    FWP.soft_refresh = true;
    FWP.refresh();
});

// FacetWP Pagination - scroll top on interaction with pagination
$(document).on('facetwp-loaded', function () {
    if (FWP.loaded) {
        const facetwpTemplateLocation = $('.facetwp-template').offset().top;
        $('html, body').animate({ scrollTop: facetwpTemplateLocation - 150 }, 500);

        // ask observer to recheck which elements on the page should be observed
        document.querySelectorAll(selector).forEach((element) => {
            observer.observe(element);
            console.log(element);
        });
    }
});



// WEBPACK FOOTER //
// ./scripts/routes/other/facetwp.js